import { selectCurrentEntitiesByIds } from 'ducks/entities/selectors'

export const selectConversationsByIds = (state, ids) =>
  selectCurrentEntitiesByIds(state, 'conversation', ids)
